// @ts-check
import Cookies from 'js-cookie';

/**
 * @param {Record<string, string>} query
 * @returns
 */
export const handleTracking = (query) => {
    if (Object.keys(query).length === 0 && document.referrer === null) return;

    const ga = {
        utm_source: query.utm_source || null,
        utm_medium: query.utm_medium || null,
        utm_campaign: query.utm_campaign || null,
        referer: document.referrer || null,
    };

    if ((ga.utm_source && ga.utm_medium && ga.utm_campaign) || ga.referer) {
        // @ts-expect-error
        Cookies.set('ga', ga);
    }

    if (query.a8) {
        Cookies.set('a8', query.a8, { expires: 90 });
    }

    if (query.cid) {
        Cookies.set('afb_key', query.cid, { expires: 90 });
    }
};
